var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76994 5L4.06194 18.746C4.12017 19.0963 4.30075 19.4145 4.57157 19.6441C4.84239 19.8737 5.18588 19.9998 5.54094 20H12.4589C12.814 19.9998 13.1575 19.8737 13.4283 19.6441C13.6991 19.4145 13.8797 19.0963 13.9379 18.746L16.2299 5H1.76994ZM2.58144 18.9935C2.69826 19.694 3.05979 20.3303 3.6017 20.7893C4.14362 21.2482 4.83078 21.5001 5.54094 21.5H12.4589C13.1691 21.5001 13.8563 21.2482 14.3982 20.7893C14.9401 20.3303 15.3016 19.694 15.4184 18.9935L17.9999 3.5H-6.10352e-05L2.58144 18.9935Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 3.5C17.9999 5.1575 13.9709 6.5 8.99994 6.5C4.02894 6.5 -6.10352e-05 5.1575 -6.10352e-05 3.5C-6.10352e-05 1.8425 4.02894 0.5 8.99994 0.5C13.9709 0.5 17.9999 1.8425 17.9999 3.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3499 3.5C16.0799 3.29 15.6044 3.0395 14.8889 2.801C13.4504 2.321 11.3699 2 8.99994 2C6.62994 2 4.54794 2.3225 3.11094 2.801C2.39544 3.041 1.91844 3.2915 1.64844 3.5C1.91844 3.71 2.39544 3.9605 3.11094 4.199C4.54794 4.679 6.62994 5 8.99994 5C11.3699 5 13.4504 4.6775 14.8889 4.199C15.6044 3.959 16.0814 3.7085 16.3514 3.5H16.3499ZM8.99994 6.5C13.9709 6.5 17.9999 5.1575 17.9999 3.5C17.9999 1.8425 13.9709 0.5 8.99994 0.5C4.02894 0.5 -6.10352e-05 1.8425 -6.10352e-05 3.5C-6.10352e-05 5.1575 4.02894 6.5 8.99994 6.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.233e0e851e33314addc30d64bbc02816.svg";
export { ForwardRef as ReactComponent };